import React from 'react';

import { Alert } from '..';

type Props = {
  dataId: string,
};

function ApiAlert(props: Props) {
  const { dataId } = props;
  return (
    <div className="u__order--error">
      <Alert
        dataId={dataId}
        alertType="danger"
        alertTitle="We're Sorry! "
        alertMessage="A temporary connection error prevented your request from going through. Please try again."
      />
    </div>
  );
}

export default ApiAlert;
